import type { Action } from 'redux';
import type { Kind } from '../../../../main/screens/ScreenLinkHubAdLinkCreator/steps/GeneralStep/General.types';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateKind = new ReduxAsyncAction<'UPDATE_KIND', Kind, { kind: Kind }>('UPDATE_KIND');

UpdateKind.registerRequest(async (kind: Kind) => {
  return { kind };
});

export const UPDATE_KIND = UpdateKind.actionNamespaceConstants;
export const updateKind = UpdateKind.request;

export type UpdateKindResponseAction = Action<typeof UPDATE_KIND.response> & {
  data: { kind: Kind };
};
